import React from 'react';
import bemify from 'bemify-js';

import BashCodeBlock from '../components/BashCodeBlock';
import Paragraph from '../components/Paragraph';
import StepTitle from '../components/StepTitle';

const bem = bemify('clone-example');
const repoName = 'zapier-platform-example-app-github';

const CloneExample = () => (
  <div className={bem()}>
    <StepTitle>Clone the Example App</StepTitle>
    <Paragraph>
      In this step, you will download a super simple Zapier application that
      works with GitHub issues. You'll be able to explore the project code, run
      automated tests, deploy it to the Zapier platform, and use it in Zaps.
    </Paragraph>
    <Paragraph>
      To clone the sample application and load its node project modules, execute
      the following commands in your terminal:
    </Paragraph>
    <BashCodeBlock
      lines={[
        {
          content: `git clone https://github.com/zapier/${repoName}.git`,
          isCommand: true,
        },
        {
          content: `cd ${repoName}`,
          isCommand: true,
        },
        {
          content: 'npm install',
          isCommand: true,
        },
      ]}
    />
    <Paragraph>
      Well done! You now have a working project in your local environment that's
      ready to deploy. Before we do that let's take a moment and have a quick
      look around the project.
    </Paragraph>
  </div>
);

export default CloneExample;
